document.addEventListener("DOMContentLoaded", () => {

    const wrapper = document.querySelector(".contact-upload");

    if (!wrapper) return;

    const dropzone = document.getElementById("ContactUpload");
    const input = document.querySelector(".UploadInput");
    const hiddenInput = document.getElementById("ContactUploadUrl");

    const filename = document.getElementById("ContactUploadFilename");
    const loading = document.getElementById("ContactUploadLoading");
    const error = document.getElementById("ContactUploadError");

    const form = wrapper.closest("form");
    const submitBtn = form.querySelector('[type="submit"]');

    /*
    =====================================
    Cloudinary
    =====================================
    */

    const CLOUD_NAME = "z6id9wum";

    const UPLOAD_PRESET = "shopify-contact";

    /*
    =====================================
    Click Upload
    =====================================
    */

    dropzone.addEventListener("click", () => {
        input.click();
    });

    /*
    =====================================
    Input Change
    =====================================
    */

    input.addEventListener("change", () => {

        if (!input.files.length) return;

        uploadFile(input.files[0]);

    });

    /*
    =====================================
    Drag Events
    =====================================
    */

    dropzone.addEventListener("dragover", e => {

        e.preventDefault();

        dropzone.classList.add("is-dragover");

    });

    dropzone.addEventListener("dragleave", () => {

        dropzone.classList.remove("is-dragover");

    });

    dropzone.addEventListener("drop", e => {

        e.preventDefault();

        dropzone.classList.remove("is-dragover");

        if (!e.dataTransfer.files.length) return;

        uploadFile(e.dataTransfer.files[0]);

    });

    /*
    =====================================
    Upload
    =====================================
    */

    async function uploadFile(file){

        clearState();

        /*
        --------------------
        Validate Type
        --------------------
        */

        const allow = [

            "image/jpeg",

            "image/png",

            "image/gif",

            "image/svg+xml"

        ];

        if(!allow.includes(file.type)){

            return showError("Only JPG, PNG, GIF, SVG.");

        }

        /*
        --------------------
        Validate Size
        --------------------
        */

        if(file.size > 5 * 1024 * 1024){

            return showError("Maximum file size is 5MB.");

        }

        /*
        --------------------
        Loading
        --------------------
        */

        wrapper.classList.add("is-uploading");

        loading.textContent = "Uploading...";

        submitBtn.disabled = true;

        /*
        --------------------
        FormData
        --------------------
        */

        const formData = new FormData();

        formData.append("file", file);

        formData.append("upload_preset", UPLOAD_PRESET);

        try{

            const response = await fetch(

                `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,

                {

                    method:"POST",

                    body:formData

                }

            );

            const data = await response.json();

            console.log(data);

            if(!response.ok){

                throw new Error(data.error?.message || "Upload failed");

            }

            if(!data.secure_url){

                throw new Error("Cannot get image url.");

            }

            /*
            --------------------
            Success
            --------------------
            */

            hiddenInput.value = data.secure_url;

            filename.innerHTML = "✔ " + file.name;

            wrapper.classList.add("is-success");

        }

        catch(err){

            console.error(err);

            showError(err.message);

        }

        finally{

            wrapper.classList.remove("is-uploading");

            loading.textContent = "";

            submitBtn.disabled = false;

        }

    }

    /*
    =====================================
    Clear
    =====================================
    */

    function clearState(){

        wrapper.classList.remove("is-success");

        wrapper.classList.remove("is-error");

        filename.innerHTML = "";

        error.innerHTML = "";

        hiddenInput.value = "";

    }

    /*
    =====================================
    Error
    =====================================
    */

    function showError(message){

        wrapper.classList.add("is-error");

        error.innerHTML = message;

    }

});